export default __webpack_public_path__ + "static/media/banner img.49422fcd.png";